export default __webpack_public_path__ + "static/media/50_desktop.4435527e.jpg";